import styles from './FAQItem.module.css';

interface FAQItemProps {
  answer: string;
  question: string;
}

export function FAQItem({ answer, question }: FAQItemProps) {
  return (
    <article className={styles.item}>
      <h3 className={styles.question}>{question}</h3>
      <p className={styles.answer}>{answer}</p>
    </article>
  );
}
